<template>
  <div class="hm-rating-info-container">
    <div class="title">{{ $t('hm.resume.hiringManagerRating') }}</div>
    <div class="rating-container">
      <div class="total-score">
        <span class="description">Overall</span>
        <span class="score">{{ total_avg_score }}</span>
      </div>
      <div
        class="rating-item-container"
        v-for="(item, index) in ratingList"
        :key="index"
        >
        <span class="hm-name">{{ item.hm_name }}:</span>
        <span class="rating-time">{{ item.submit_time }}</span>
        <div class="rate-container">
          <van-rate class="rating-rate" v-model="item.total_rate" size="28" color="#808080" :readonly="true" :count="6"/>
          <div class="rating-status status-outer" :class="getRatingColorByStatus(item.status)">
            <div class="status-inner"></div>
          </div>
        </div>
        <div class="comment-container">
          <span class="title">{{ $t('hm.label.commentLabel') }} </span>
          <span class="value">{{ item.comment }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import _ from 'lodash'

export default {
  components: {
  },
  props: {
    hmRatingInfo: {
      require: true
    }
  },
  data () {
    return {
      ratingList: [
        // {
        //   hm_name: 'garvinzhu',
        //   submit_time: '2022-06-12 14:20',
        //   comment: 'garvin测试'

        // }
      ],
      total_avg_score: 0
    }
  },
  computed: {
  },
  created () {
    this.ratingList = this.hmRatingInfo.rate_list
    this.total_avg_score = this.hmRatingInfo.total_avg_rate
    this.ratingList.forEach(item => {
      item.total_rate = _.parseInt(item.total_rate)
    })
  },
  beforeDestroy () {

  },
  methods: {
    getRatingColorByStatus (status) {
      if (status === 2 || status === '2') {
        return 'green'
      } else if (status === 0 || status === '0') {
        return 'red'
      } else if (status === 1 || status === '1') {
        return 'yellow'
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.hm-rating-info-container {
  margin: 20px 0;

  > .title {
    font-size: 16px;
    padding: 10px 0 5px 10px;
    border-bottom: 1px solid #b4b4b4;
    margin-bottom: 20px;
    font-weight: 600;
  }

  .rating-container {
    position: relative;
    background-color: #FFFFFF;
    padding: 10px;
    color: #606266;

    .total-score {
      position: absolute;
      right: 0px;
      top: -62px;
      background-color: #FFFFFF;
      width: 80px;
      height: 80px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border: 5px solid #6666;
      border-radius: 50%;

      .score {
        font-size: 34px;
        font-weight: 700;
        color: #909399;
      }
    }

    .rating-item-container {
      display: flex;
      flex-direction: column;
      padding: 12px 20px 0 20px;
      margin-bottom: 10px;
      background: #f7f7f7;
      font-size: 12px;

      &:last-child {
        margin-bottom: 0;
      }

      .hm-name {
        font-size: 16px;
        margin-bottom: 5px;
      }

      .rate-container {
        display: flex;
        margin: 10px 0;
        justify-content: space-between;

        .rating-status {
          border: 1px solid #808080;
          padding: 4px;
          height: 18px;
          width: 18px;
          border-radius: 50%;

          .status-inner {
            background-color: #808080;
            height: 18px;
            width: 18px;
            border-radius: 50%;
          }

          &.green {
            border-color: #008000;

            .status-inner {
              background-color: #008000;
            }
          }

          &.red {
            border-color: #ff0000;

            .status-inner {
              background-color: #ff0000;
            }
          }

          &.yellow {
            border-color: #ffff00;

            .status-inner {
              background-color: #ffff00;
            }
          }
        }
      }

      .comment-container {
        font-size: 16px;
        .value {
          white-space: pre-wrap;
        }
      }

    }
  }

  ::v-deep .rating-rate {
    width: 80%;

    .van-rate__item:not(:last-child) {
      padding-right: 10px;
    }
  }
}
</style>
